const EffectiveContractsTeacherPage = () => import(
  "../../../components/application/effective_contract/app/pages/EffectiveContractsTeacherPage.vue"
);

const EffectiveContractsOrderFormPage = () => import(
  "../../../components/application/effective_contract/app/pages/EffectiveContractsOrderFormPage.vue"
);

const EffectiveContractUMUPage = () => import(
  "../../../components/application/effective_contract/app/pages/EffectiveContractUMUPage.vue"
);

export const routes = [
  {
    path: '/effective_contracts/app',
    name: 'effective-contracts-teachers-page',
    component: EffectiveContractsTeacherPage,
  },
  {
    path: '/effective_contracts/app/order',
    name: 'effective-contracts-order-form-page',
    component: EffectiveContractsOrderFormPage,
  },
  {
    path: '/effective_contracts/app/umu',
    name: 'effective-contracts-umu-page',
    component: EffectiveContractUMUPage,
  },
]